import { Cirus } from "@/classes/Http";
import { objectToQuery } from "../../ObjectToQuery";

export class GetInstanceProductsQuery {
    per_page? = 20;
    page = 0;
    search?: string;
    suggested?: boolean;
    sort?: string;
    min_price? = 0;
    max_price?: number;
    similar_to?: string;
    category?: string;
    filters?: string[];
    only_available?: boolean;
    discounted?: boolean;
}

export function getProducts(instance_id: number, params: GetInstanceProductsQuery) {
    const query = `/instance/${instance_id}/products?${objectToQuery(params)}`;
    return Cirus.get(query);
}